import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { RemoveFromCartMutation as RemoveFromCartMutationType, RemoveFromCartMutationVariables } from "gql/types/mutations/RemoveFromCartMutation";

const text = gql`mutation RemoveFromCartMutation($removeFromCartInput: MutationRemoveFromCartInput!) {
	removeFromCart(removeFromCartInput: $removeFromCartInput) {
		order {
			id
		}
	}
}
`;

const RemoveFromCartMutation: IOperation<RemoveFromCartMutationType, RemoveFromCartMutationVariables> = { text } as any;

export default RemoveFromCartMutation;
